import { render, staticRenderFns } from "./TifJustificacionesMapa.vue?vue&type=template&id=6f3b5c7a"
import script from "./TifJustificacionesMapa.vue?vue&type=script&lang=js"
export * from "./TifJustificacionesMapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports